import React from "react";
import { Route, Switch } from "react-router-dom";
import CountryAdminVendorsTable from "./CountryAdminVendorsTable";
import CountryAdminVendorPage from "./CountryAdminVendorPage";
import VendorsImportDetailedPage from "./VendorsImportDetailedPage";

const CountryAdminVendors = () => {
  const renderCountryAdminVendorPageCreate = () => {
    return <CountryAdminVendorPage create={true} />;
  };

  const renderCountryAdminVendorPageEdit = () => {
    return <CountryAdminVendorPage create={false} />;
  };

  return (
    <div className="admin-vendors country-admin-main-content">
      <Switch>
        <Route
          path="/countryAdmin/vendors/create"
          component={renderCountryAdminVendorPageCreate}
        />
        <Route
          path="/countryAdmin/vendors/allVendors/:vendorId"
          component={renderCountryAdminVendorPageEdit}
        />
        <Route
          path="/countryAdmin/vendors/newVendors/:vendorId"
          component={renderCountryAdminVendorPageEdit}
        />
        <Route
          path="/countryAdmin/vendors/vendorsImports/:vendorsImportId"
          component={VendorsImportDetailedPage}
        />
        <Route component={CountryAdminVendorsTable} />
      </Switch>
    </div>
  );
};

export default CountryAdminVendors;
